// extracted by mini-css-extract-plugin
module.exports = {"studentProgressBar":"styles_studentProgressBar__32wKw"};